import { useEnableDataObjects } from "./useEnableDataObjects";
import { useIsClientUserKind } from "./useIsClientUserKind";

/**
 * Hook to determine if the current user is a third-party user with OS3 (Data Objects) enabled
 */
export const useIsOS3EnabledThirdPartyUser = () => {
  const isThirdPartyUserKind = !useIsClientUserKind();
  const isDataObjectsEnabled = useEnableDataObjects();

  return isThirdPartyUserKind && isDataObjectsEnabled;
};
